/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmMatchingPolicyDetailDto
 */
export interface MdmMatchingPolicyDetailDto {
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    configurationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    policyId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    policyVersionLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof MdmMatchingPolicyDetailDto
     */
    configurationVersion?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyDetailDto
     */
    activeForAssetClass?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyDetailDto
     */
    prospectiveOnly?: boolean;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MdmMatchingPolicyDetailDto
     */
    rules?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MdmMatchingPolicyDetailDto
     */
    guards?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MdmMatchingPolicyDetailDto
     */
    thresholds?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MdmMatchingPolicyDetailDto
     */
    pipeline?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof MdmMatchingPolicyDetailDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MdmMatchingPolicyDetailDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmMatchingPolicyDetailDto
     */
    updatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MdmMatchingPolicyDetailDto
     */
    legacySystemDefault?: boolean;
}

/**
 * Check if a given object implements the MdmMatchingPolicyDetailDto interface.
 */
export function instanceOfMdmMatchingPolicyDetailDto(value: object): value is MdmMatchingPolicyDetailDto {
    return true;
}

export function MdmMatchingPolicyDetailDtoFromJSON(json: any): MdmMatchingPolicyDetailDto {
    return MdmMatchingPolicyDetailDtoFromJSONTyped(json, false);
}

export function MdmMatchingPolicyDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmMatchingPolicyDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'status': json['status'] == null ? undefined : json['status'],
        'policyVersionLabel': json['policyVersionLabel'] == null ? undefined : json['policyVersionLabel'],
        'configurationVersion': json['configurationVersion'] == null ? undefined : json['configurationVersion'],
        'activeForAssetClass': json['activeForAssetClass'] == null ? undefined : json['activeForAssetClass'],
        'prospectiveOnly': json['prospectiveOnly'] == null ? undefined : json['prospectiveOnly'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'guards': json['guards'] == null ? undefined : json['guards'],
        'thresholds': json['thresholds'] == null ? undefined : json['thresholds'],
        'pipeline': json['pipeline'] == null ? undefined : json['pipeline'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'legacySystemDefault': json['legacySystemDefault'] == null ? undefined : json['legacySystemDefault'],
    };
}

export function MdmMatchingPolicyDetailDtoToJSON(json: any): MdmMatchingPolicyDetailDto {
    return MdmMatchingPolicyDetailDtoToJSONTyped(json, false);
}

export function MdmMatchingPolicyDetailDtoToJSONTyped(value?: MdmMatchingPolicyDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationId': value['configurationId'],
        'policyId': value['policyId'],
        'assetClass': value['assetClass'],
        'displayName': value['displayName'],
        'status': value['status'],
        'policyVersionLabel': value['policyVersionLabel'],
        'configurationVersion': value['configurationVersion'],
        'activeForAssetClass': value['activeForAssetClass'],
        'prospectiveOnly': value['prospectiveOnly'],
        'rules': value['rules'],
        'guards': value['guards'],
        'thresholds': value['thresholds'],
        'pipeline': value['pipeline'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'legacySystemDefault': value['legacySystemDefault'],
    };
}

